/**
 * Helper function to convert templateUrl to template using the TemplateCacheService
 * @param {string} templateUrl - The URL of the template
 * @returns {Function} A function that returns the template content
 */
export function getTemplate(templateUrl) {
  return ['TemplateCacheService', function(TemplateCacheService) {
    return TemplateCacheService.getTemplate(templateUrl);
  }];
}

/**
 * Creates a component configuration object with template loaded via TemplateCacheService
 * @param {Object} config - The component configuration
 * @param {string} config.templateUrl - The URL of the template
 * @param {Object} [config.bindings] - Component bindings
 * @param {Object} [config.controller] - Component controller
 * @param {Array} [config.require] - Component requires
 * @param {Object} [config.transclude] - Component transclude
 * @returns {Object} The component configuration with template instead of templateUrl
 */
export function createComponent(config) {
  if (!config.templateUrl) {
    return config;
  }

  const { templateUrl, ...rest } = config;
  return {
    ...rest,
    template: getTemplate(templateUrl)
  };
}
